import "./styles.scss"
import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import { TPages } from "./types"
import PagesListing from "./containers/listing"
import { PagesContext } from "./context"
import PageDetails from "./containers/details"

export default function Pages({ }: TPages) {
    return <ContentSectionContainer className="pagesContainer">
        <PagesContext.Provider value={{}}>
            <Routes>

                <Route index path={fetchRoute({ route: ERoutes.pages })} element={<PagesListing />} />
                <Route path={fetchRoute({ route: ERoutes.pageDetails })} element={<PageDetails />} />
                <Route path={fetchRoute({ route: ERoutes.pageEdit })} element={<PageDetails />} />

                <Route index path={"/"} element={<PagesListing />} />
                <Route index path={"/:pageId"} element={<PageDetails />} />
                <Route index path={"/:pageId/edit"} element={<PageDetails />} />

            </Routes>
        </PagesContext.Provider>
    </ContentSectionContainer >
}   